// extracted by mini-css-extract-plugin
module.exports = {"body-text":"programs_body-text__CWx68","content-wrapper":"programs_content-wrapper__Sm_4u"};